
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable()
    export class ProdottiDialog extends Serenity.EntityDialog<ProdottiRow, any> {
        protected getFormKey() { return ProdottiForm.formKey; }
        protected getIdProperty() { return ProdottiRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiRow.localTextPrefix; }
        protected getNameProperty() { return ProdottiRow.nameProperty; }
        protected getService() { return ProdottiService.baseUrl; }
        protected getDeletePermission() { return ProdottiRow.deletePermission; }
        protected getInsertPermission() { return ProdottiRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiRow.updatePermission; }

        protected form = new ProdottiForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            var buttonApply = Q.first(buttons, x => x.cssClass == "apply-changes-button");
            buttonApply.title = "Salva e continua";

            //
            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

                //Remove Button
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            }

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            // Questa gestisce l'editor.
            this.form.BadgeList.IdProdotto = this.form.IdProdotto.value;

            // Questa gestisce l'editor.
            //this.form.ClassiList.ambito = ProdottiClassiEditor.AmbitoEnum.VisualizzaClasse;
            this.form.ClassiList.IdProdotto = this.form.IdProdotto.value;

            // Questa gestisce l'editor.
            this.form.EsperienzeList.idProdotto = this.form.IdProdotto.value;

            // Questa gestisce l'editor.
            this.form.RisorseList.ambito = ProdottiRisorse2Editor.AmbitoEnum.VisualizzaRisorse;
            this.form.RisorseList.idProdotto = this.form.IdProdotto.value;

            // Enzo: commentata perchè il 20231006 hanno modificato i requisiti utenti.
            // Questa gestisce l'editor.
            // this.form.AssetEsperienzeList.ambito = ProdottiAssetEsperienze2Editor.AmbitoEnum.VisualizzaAssetEsperienze;
            // this.form.AssetEsperienzeList.idProdotto = this.form.IdProdotto.value;

            MyQ.hideEditorTab(this.form.BadgeList, this.isNewOrDeleted());
            MyQ.hideEditorTab(this.form.ClassiList, this.isNewOrDeleted());
            MyQ.hideEditorTab(this.form.LivelliList, this.isNewOrDeleted());
            MyQ.hideEditorTab(this.form.EsperienzeList, this.isNewOrDeleted());
            MyQ.hideEditorTab(this.form.RisorseList, this.isNewOrDeleted());
        }
    }
}
